import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import {HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS} from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {UserService} from "./_services/user.service";
import {GuardService} from "./_services/guard.service";
import {ToasterModule} from 'angular2-toaster';

import { P404Component } from './_routes/error/404.component';
import { P500Component } from './_routes/error/500.component';

import {JwtModule} from "@auth0/angular-jwt";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";

import {ModalModule} from "ngx-bootstrap/modal";
import {AuthInterceptor} from "./_services/http-interceptor.interceptor";

export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
  declarations: [
    AppComponent,
    P404Component,
    P500Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    HttpClientJsonpModule,
    BsDatepickerModule.forRoot(),
    ToasterModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    ModalModule
  ],
  providers: [
    UserService,
    GuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
